// src/hooks/useAudioPreload.js
import { useEffect, useRef, useCallback } from 'react';
import { API_BASE_URL } from '../constants';

/**
 * 预加载成功/失败提示音并返回播放回调
 */
const useAudioPreload = () => {
  const successSoundRef = useRef(null);
  const errorSoundRef = useRef(null);

  useEffect(() => {
    successSoundRef.current = new Audio(`${API_BASE_URL}/sound/chenggong.mp3`);
    successSoundRef.current.load();

    errorSoundRef.current = new Audio(`${API_BASE_URL}/sound/shibai.mp3`);
    errorSoundRef.current.load();

    return () => {
      if (successSoundRef.current) {
        successSoundRef.current.pause();
        successSoundRef.current.src = '';
        successSoundRef.current = null;
      }
      if (errorSoundRef.current) {
        errorSoundRef.current.pause();
        errorSoundRef.current.src = '';
        errorSoundRef.current = null;
      }
    };
  }, []);

  const playCompletionSound = useCallback(() => {
    try {
      if (successSoundRef.current) {
        successSoundRef.current.currentTime = 0;
        successSoundRef.current.play().catch(err => console.warn('成功提示音播放失败:', err));
      }
    } catch (err) {
      console.warn('成功提示音播放失败:', err);
    }
  }, []);

  const playErrorSound = useCallback(() => {
    try {
      if (errorSoundRef.current) {
        errorSoundRef.current.currentTime = 0;
        errorSoundRef.current.play().catch(err => console.warn('失败提示音播放失败:', err));
      }
    } catch (err) {
      console.warn('失败提示音播放失败:', err);
    }
  }, []);

  return { playCompletionSound, playErrorSound };
};

export default useAudioPreload;
